import Profile from './Profile'
import Financial from './Financiol'
import Deposit from './Deposit'
import Withdraw from './Withdraw'
import Messages from './Messages'
import Setting from './Setting'
import { CardButton, RoundButton } from '@sabavision/dio'
import { Icon, Row, ProfilePic } from './styled'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Istate } from '../../reducers/types'
import { useNavigate } from 'react-router-dom'
import { logout } from '../../api/auth'

export interface menuItemType {
  name: string
  label: string
  icon: string
}
export interface menuItemsType {
  name: string
  label: string
  icon: string
  disabled: boolean
  badge: number
}

interface SmallHeaderProps {
  closeSection: () => void
}
function SmallHeader(props: SmallHeaderProps) {
  const user = useSelector((state: Istate) => state.user)
  return (
    <div className="small">
      <div className="row">
        <span className="user">
          {user?.avatar?.url ? (
            <img className="avatar" src={user.avatar.url} alt={user.first_name} />
          ) : (
            <span className="dio-person" />
          )}
          {user.first_name} {user.last_name}
        </span>
      </div>
      <RoundButton
        data-test="round-button-sidebar"
        icon="iconsax-arrow-right-3"
        size="22px"
        handleClick={props.closeSection}
      />
    </div>
  )
}

interface SectionProps {
  closeSection: () => void
  sectionName: string
}

function Section(props: SectionProps) {
  if (props.sectionName === 'profile') {
    return <Profile closeSection={props.closeSection} />
  } else if (props.sectionName === 'financialData') {
    return <Financial />
  } else if (props.sectionName === 'deposit') {
    return <Deposit />
  } else if (props.sectionName === 'withdraw') {
    return <Withdraw />
  } else if (props.sectionName === 'messages') {
    return <Messages />
  } else if (props.sectionName === 'setting') {
    return <Setting />
  }
  return null
}

function SectionName(props: any) {
  return (
    <span className="name">
      <span className="icon">
        <span className={props.section.icon} style={{ fontSize: '1.5rem' }}></span>
      </span>
      <span>{props.section.label}</span>
    </span>
  )
}

interface SectionsProps {
  openSection: (item: menuItemsType) => void
  profileButtons: menuItemsType[]
}
function Sections(props: SectionsProps) {
  return (
    <Row>
      {props.profileButtons.map((item: menuItemsType, index: number) => (
        <CardButton
          key={index}
          badge={item.badge}
          icon={item.icon}
          label={item.label}
          handleClick={() => {
            props.openSection(item)
          }}
          disabled={!!item.disabled}
        />
      ))}
    </Row>
  )
}

interface WalletDataProps {
  openSection: (item: menuItemsType) => void
}

function WalletData(props: WalletDataProps) {
  const { t } = useTranslation('translation', { keyPrefix: 'sidebar' })
  const wallet = useSelector((state: Istate) => state.wallet)
  const user = useSelector((state: Istate) => state.user)

  return (
    <>
      <div className="wallet">
        {t('current_credit')}:
        <span className="credit">
          {new Intl.NumberFormat('fa-IR', {
            maximumFractionDigits: 0
          }).format(wallet.advertiser_live_wallet / 10)}
        </span>
        <span className="unit">{t('toman')}</span>
      </div>

      <RoundButton
        data-test="round-button-sidebar-2"
        handleClick={() => {
          props.openSection({
            label: 'واریز',
            name: 'deposit',
            icon: 'iconsax-money-add',
            disabled: false,
            badge: 0
          })
        }}
        disabled={!(user.type === 'advertiser' && user.verification_status === 'verified')}
      />
    </>
  )
}

function LargeHeader() {
  const navigate = useNavigate()

  const user = useSelector((state: Istate) => state.user)
  const logOut = async () => {
    logout(
      () => {
        caches.keys().then((names) => {
          names.forEach((name) => {
            caches.delete(name)
          })
        })
        navigate('/login')
      },
      (error) => {
        console.log(error)
      }
    )
  }
  return (
    <div className="large">
      <ProfilePic>
        {user?.avatar?.url ? (
          <img className="avatar" src={user.avatar.url} alt={user.first_name} />
        ) : (
          <Icon className="iconsax-user" style={{ fontSize: '3.5rem' }} />
        )}
      </ProfilePic>
      <span className="role">
        {user.entity_type === 'legal_person' ? (
          <span className="name">{user.company_name}</span>
        ) : (
          <span className="name">
            {user.first_name} {user.last_name}
          </span>
        )}
        <span
          className={`iconsax-logout logout ${user.company_name || user.first_name || user.last_name ? '' : 'center'}`}
          onClick={() => {
            logOut()
          }}
        />
      </span>
      <span className="mobile">{user.mobile}</span>
    </div>
  )
}

export { SmallHeader, Section, SectionName, Sections, WalletData, LargeHeader }
